import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 22 22",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("rect", {
		fill: "#000",
		width: 16.971,
		height: 16.971,
		x: 11,
		y: -1,
		rx: 4,
		transform: "rotate(45 11 -1)"
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2022%2022%22%3E%3Crect%20fill%3D%22%23000%22%20width%3D%2216.971%22%20height%3D%2216.971%22%20x%3D%2211%22%20y%3D%22-1%22%20rx%3D%224%22%20transform%3D%22rotate(45%2011%20-1)%22%2F%3E%3C%2Fsvg%3E%0A";
